import { AnimatedSprite, BaseTexture, Texture, Rectangle } from "pixi.js";
import spritesheetPng0 from "./explosion-0.png";
import spritesheetJson0 from "./explosion-0.json";

import spritesheetPng1 from "./explosion-1.png";
import spritesheetJson1 from "./explosion-1.json";

import * as PIXI from "pixi.js";

export class Explosion {
  constructor() {
    this.container;
  }

  initExplosion = () => {
    let frames0 = getTextures(
      spritesheetJson0.frames,
      PIXI.Texture.from(
        PIXI.Loader.shared.resources["spritesheetPng0"].texture.baseTexture
      )
    );
    let frames1 = getTextures(
      spritesheetJson1.frames,
      PIXI.Texture.from(
        PIXI.Loader.shared.resources["spritesheetPng1"].texture.baseTexture
      )
    );
    frames0 = frames0.concat(frames1);

    this.explosion = createSprite(frames0);
    this.explosion.anchor.set(0.5, 0.5);
    this.explosion.loop = false;
    this.explosion.animationSpeed = 0.7
    this.explosion.x = 5000;
    this.explosion.y = -36;
    this.container.addChild(this.explosion);
  };

  getExplosionResourses = () => {
    return [
      ["spritesheetPng0", spritesheetPng0],
      ["spritesheetPng1", spritesheetPng1],
    ];
  };

  setContainerForExposion = (container) => {
    //container.addChild(this.explosion);
    this.container = container;
  };

  startExplosion = () => {
    this.explosion.x = 0;
    this.container.addChild(this.explosion);
    // this.container.addChild(this.explosion)
    this.explosion.gotoAndPlay(0);
  };
  removeExplosion = () => {
    this.explosion.alpha = 0;
  };
}
export const createSprite = (textures) => {
  let sprite = new AnimatedSprite(textures);
  sprite.anchor.set(0.5, 0.5);
  sprite.loop = false;
  return sprite;
};

export const getTextures = (jsonframes, baseTxt) => {
  let frames = Object.values(jsonframes);
  let textures = frames.map((fr) => {
    const { x, y, w, h } = fr.frame;
    const txt = new Texture(baseTxt, new Rectangle(x, y, w, h));
    return txt;
  });
  return textures;
};
